(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("1tnLK", function(module, exports) {
// Swiper styles



parcelRequire("kbkiQ");
parcelRequire("afCk3");

});
parcelRegister("kbkiQ", function(module, exports) {

var $1FCkY = parcelRequire("1FCkY");

var $8h94B = parcelRequire("8h94B");
const $eb14957782c2ef11$var$heroSliders = document.querySelectorAll(".g-hero-slider");
$eb14957782c2ef11$var$heroSliders.forEach((slider)=>{
    const swiperSettings = {
        modules: [
            (0, $8h94B.Keyboard),
            (0, $8h94B.EffectCreative),
            (0, $8h94B.Pagination),
            (0, $8h94B.Navigation)
        ],
        slidesPerView: 1,
        spaceBetween: 8,
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: slider.closest(".s-hero-slider")?.querySelector(".g-hero-slider__button.--next"),
            prevEl: slider.closest(".s-hero-slider")?.querySelector(".g-hero-slider__button.--prev")
        },
        pagination: {
            el: slider.querySelector(".g-hero-slider__pagination"),
            clickable: true
        },
        effect: "creative",
        creativeEffect: {
            prev: {
                translate: [
                    0,
                    0,
                    -400
                ],
                opacity: 0
            },
            next: {
                translate: [
                    "calc(100% + 8px)",
                    0,
                    0
                ]
            }
        },
        on: {
            init: ()=>{
                slider.classList.remove("--loading");
            }
        }
    };
    new (0, $1FCkY.default)(slider, swiperSettings);
});

});

parcelRegister("afCk3", function(module, exports) {

var $1FCkY = parcelRequire("1FCkY");

var $8h94B = parcelRequire("8h94B");
const $77690822f7d3c1b0$var$heroSliders = document.querySelectorAll(".g-testimonials.--slider");
$77690822f7d3c1b0$var$heroSliders.forEach((slider)=>{
    const swiperSettings = {
        modules: [
            (0, $8h94B.Keyboard),
            (0, $8h94B.Pagination),
            (0, $8h94B.Navigation)
        ],
        slidesPerView: "auto",
        spaceBetween: 32,
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: slider.closest(".s-testimonials")?.querySelector(".g-testimonials__button.--next"),
            prevEl: slider.closest(".s-testimonials")?.querySelector(".g-testimonials__button.--prev")
        },
        pagination: {
            el: slider.querySelector(".g-testimonials__pagination"),
            clickable: true
        },
        on: {
            init: ()=>{
                slider.classList.remove("--loading");
            }
        }
    };
    new (0, $1FCkY.default)(slider, swiperSettings);
});

});


})();
//# sourceMappingURL=swiper.97cf8de3.js.map
